import React, { useEffect, useState, useRef } from "react";
import {
  AppBar,
  Avatar,
  Box,
  Container,
  IconButton,
  Link,
  Toolbar,
  Typography,
} from "@mui/material";

import Account from "./account";
import Products from "./products";
import useScreenTypeStore from "../../store/screenType";
import { HEIGHTS } from "../../utils/constants";
import { getAppData } from "../../api/app";
import { useAuthStore, useClientStore } from "store";
import { cookieAuthApi } from "api/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { COLORS } from "@shared/tapzus";

const Navbar: React.FC = () => {
  const { updateScreenType } = useScreenTypeStore();
  const { setAuth, setAuthChecked, ...auth } = useAuthStore();
  const { setClient } = useClientStore();
  const location = useLocation();
  const navigate = useNavigate();

  const [showNavbar, setShowNavbar] = useState(true);
  const [fadeIn, setFadeIn] = useState(true);
  const scrollTimeout = useRef<NodeJS.Timeout | null>(null);
  const lastScrollY = useRef(0);

  useEffect(() => {
    updateScreenType();
    window.addEventListener("resize", updateScreenType);

    if (!auth.isLogin) {
      cookieAuthApi()
        .then((response) => {
          setAuth(response.auth);
          //setClient(response.client);
        })
        .catch(() => {
          setAuthChecked();
          if (
            location.pathname !== "/login" &&
            location.pathname !== "/signup"
          ) {
            navigate("/", { state: { from: location.pathname || "/" } });
          }
        });
    }

    return () => window.removeEventListener("resize", updateScreenType);
  }, [updateScreenType]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY.current) {
        setShowNavbar(false);
        setFadeIn(false);
      } else {
        setShowNavbar(true);
        setFadeIn(true);
      }

      lastScrollY.current = currentScrollY;

      if (scrollTimeout.current) clearTimeout(scrollTimeout.current);

      scrollTimeout.current = setTimeout(() => {
        setShowNavbar(true);
        setFadeIn(true);
      }, 1500);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <AppBar
        position="fixed"
        style={{
          top: showNavbar ? 0 : "-100px",
          opacity: fadeIn ? 1 : 0,
          transition: "top 0.4s ease-in-out, opacity 0.6s ease-in-out", // Smooth transition
          height: HEIGHTS.navBar,
          backgroundColor: "#F4F1FA",
          paddingTop: "10px",
        }}
        elevation={0}
      >
        <Container
          maxWidth="xl"
          style={{ maxWidth: "calc(1280px + 64px * 2)" }}
        >
          <Toolbar
            disableGutters
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Link href="/">
              <div style={{ display: "flex", width: "200px", height: "2" }}>
                <img
                  src="/logo/tapzus-logo.png"
                  alt="Urbanline Gas"
                  style={{
                    margin: "0 8px",
                  }}
                />
              </div>
            </Link>
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <Products isFlex={true} />
            </Box>
            <div>
              <Account />
            </div>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};

export default Navbar;
